import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export const getBrandIdentityUrl = () => {
  const appUrl = getFullUrl('app');
  return `${appUrl}/brand-identity/${PortalIdParser.get()}/brand/`;
};